<template>
  <generic-modal
    v-if="noInternet"
    :width="errorModal.width"
    :modalClass="errorModal.modalClass"
    :height="errorModal.height"
  >
    <template v-slot:header></template>
    <template v-slot:body>
      <div>
        <error-screen
          :data-image="
            staticImgBaseUrl + '/images/global/img-location-not-found.svg'
          "
          :data-title="'Unable to detect your location'"
          :data-sub-title="'Please check your internet connection'"
          :data-cta="'Try again'"
        ></error-screen>
      </div>
    </template>
    <template v-slot:footer>
      <div></div>
    </template>
  </generic-modal>
</template>
<script>
import ErrorScreen from "./ErrorScreen.vue";
import { staticImgBaseUrl } from "../config/apiEndpoints";
import GenericModal from "./GenericModal.vue";

export default {
  components: { GenericModal, ErrorScreen },
  name: "LocationNotFound",
  data() {
    return {
      staticImgBaseUrl,
      errorModal: {
        width: "100vw",
        height: "100%",
        modalClass: "full-screen-popup",
      },
    };
  },
  computed: {
    noInternet() {
      return this.$store.state.Location.noInternet;
    },
  },
};
</script>
